<template>
  <v-row>
    <v-col cols="12" class="mx-auto" notes>
      <v-card class="elevation-0">
        <Paging
          :resourceSettings="resourceSettings"
          :resource="notes"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>
          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.stop="$emit('openDialog', 'note')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="notes.data && notes.data.length > 0">
            <v-col v-for="(note, key) in notes.data" :key="`note-${key}`" md="4" cols="12">
              <v-card>
                <v-card-text>
                  <div>{{ note.employee_name.name }}</div>
                  <p :class="`${arabic ? 'arFont' : 'enFont'}`" class="text-h4 text--primary">
                    {{ getFormat(note.created_at) }}
                  </p>
                  <div :class="`${arabic ? 'arFont' : 'enFont'}`" class="text--primary">
                    {{ note.note }}
                  </div>
                  <v-row>
                    <v-col class="pb-0">
                      <div>
                        <v-btn small @click.prevent="$emit('editResource', 'note', note)" class="mr-2" color="primary">
                          Edit
                        </v-btn>
                        <v-btn small @click.prevent="$emit('deleteResource', 'note', note)" color="error">Delete</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { format } from "timeago.js";
import Paging from "@/components/Paging";

export default {
  components: { Paging },
  props: ["notes"],
  data() {
    return {
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    getFormat(d) {
      return format(d);
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    firstLettersName(name) {
      const split_names = name.split(" ");

      if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase();

      return (split_names[0][0] + split_names[0][1]).toUpperCase();
    },
    loadResource() {
      this.$emit("loadResource", "notes", "notes");
    },
    pageByNumber(page) {
      this.$emit("pageByNumber", "notes", "notes", page);
    },
  },
};
</script>
